<template>
  <form @submit.prevent="authenticateSocSecNr" autocomplete="off">
    <v-row no-gutters align="center" justify="space-between">
      <v-col>
        <span v-if="isCompany">{{ $t('companyText') }}</span>
        <span v-else>{{ $t('privateText') }}</span>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-row no-gutters align="center">
          <v-col :class="{ 'px-6': $vuetify.breakpoint.mdAndUp, 'mr-3': $vuetify.breakpoint.smAndDown }">
            <v-text-field name="socSecNr"
                          class="color-grey--text"
                          solo
                          hide-details
                          flat
                          :label="$t('socSecNr')"
                          id="socSecNr"
                          v-model="socSecNr"
                          required></v-text-field>
          </v-col>
          <div class="pa-3">
            <v-btn tile depressed dark class="color-black" type="submit" :disabled="!isSSNValid || loading" :loading="loading">
              {{ $t('buttonText') }}
            </v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
  export default {
    data: function () {
      return {
        socSecNr: '',
        loading: false
      }
    },
    computed: {
      isSSNValid () {
        if (this.isCompany) {
          return true
        } else {
          let validation = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d[-U-Y]|[012]\d[A-F])\d{3}[\dA-Z]$/.test(this.socSecNr.toUpperCase())

          return validation
        }
      },
      isCompany () {
        var debtor = this.$store.getters.debtor
        if (debtor !== null) {
          return debtor.isCompany
        } else {
          return false
        }
      }
    },
    methods: {
      authenticateSocSecNr () {
        if (this.isSSNValid) {
          this.loading = true
          this.$store.dispatch('authenticateSocSecNr', { LoginType: 3, Identifier: this.socSecNr }).then(() => {
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "privateText": "Huom! Sinulla on palvelussa muitakin velkoja, syötä henkilötunnuksesi nähdäksesi kokonaistilanteesi",
  "companyText": "Huom! Sinulla on palvelussa muitakin velkoja, syötä Y-tunnuksesi nähdäksesi kokonaistilanteesi",
  "buttonText": "Tarkista"
  },
  "se": {
  "privateText": "Obs! Du har fler obetalda fakturor som registrerats i  webbtjänsten, uppge din personnummer om du vill ha en helhetsöversikt",
  "companyText": "Obs! Du har fler obetalda fakturor som registrerats i webbtjänsten, uppge din FO-nummer om du vill ha en helhetsöversikt",
  "buttonText": "Kontrollera"
  },
  "en": {
  "privateText": "Note! You have additional debts in our system. To see all the information please provide your social security number.",
  "companyText": "Note! You have additional debts in our system. To see all the information please provide your business ID.",
  "buttonText": "Check"
  }
  }
</i18n>
